import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../utils/type';
import { selectVendorList, selectVendorListLoading } from '../pages/vendors/services/vendorList/selectors';
import { getVendorList } from '../pages/vendors/services/vendorList/crudFunctions';

interface Props {
  value: number | undefined;
  onChange: (vendorId: number | undefined) => void;
  label?: string;
}

const VendorSelect: React.FC<Props> = ({ value, onChange, label = 'Vendor' }) => {
  const dispatch = useDispatch();
  const vendors = useSelector((s: RootState) => selectVendorList(s));
  const loading = useSelector((s: RootState) => selectVendorListLoading(s));

  useEffect(() => {
    if (vendors.length === 0) {
      dispatch<any>(getVendorList());
    }
  }, [dispatch, vendors.length]);

  return (
    <div>
      <label className="form-label">{label}</label>
      <select
        className="form-select"
        value={value ?? ''}
        onChange={(e) =>
          onChange(e.target.value ? Number(e.target.value) : undefined)
        }
        disabled={loading}
      >
        <option value="">
          {loading ? 'Loading vendors...' : 'All Vendors'}
        </option>
        {vendors.map((v) => (
          <option key={v.id} value={v.id}>
            {v.owner_legal_name}
            {v.business_name ? ` — ${v.business_name}` : ''}
            {' '}({v.mobile_number})
          </option>
        ))}
      </select>
    </div>
  );
};

export default VendorSelect;
